import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, Chip } from '@mui/material';
import { useSiteVarsFunctions } from "../hooks/use-site-vars-functions";

import { green, red} from "@mui/material/colors";
import { ArrowUpward, ArrowDownward } from '@mui/icons-material';

export const TeamDisplayTable = (props) => {
  const {getPlayerPositionById, getTeamById } = useSiteVarsFunctions();

  let playerArr = props.teamData.players.slice(0);
  playerArr.sort((a,b) => {
    let positionOrder = a.positionId - b.positionId;
    let nameOrder = a.name - b.name;
    return positionOrder || -nameOrder;
  });

  return (
      <TableContainer component={Paper}>
      <Table sx={{ minWidth: 340 }} size="small">
        <TableHead>
          <TableRow>
            <TableCell >Player</TableCell>
            <TableCell>Cost</TableCell>
            <TableCell>Week</TableCell>
            <TableCell>Total</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {playerArr.map((row) => (
              <TableRow key={row.lastName}>
              <TableCell ><span>{row.lastName}</span>
              {row.transfer === "in" && <span> <Chip label="in" color="success" size="small" /></span>}
                {row.transfer === "out" && <span> <Chip label="out" color="warning" size="small" /></span>}
                <br />
                <span style={{fontWeight: 'bold'}}>{getPlayerPositionById(row.positionId).name_short}</span> {getTeamById(row.teamId).name_short}</TableCell>
              <TableCell >{row.originalCost}</TableCell>
              <TableCell >{row.eventPoints}</TableCell>
              <TableCell >{row.totalPoints}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      
    </TableContainer>
  );
};
